<template>
	<div class="footer">
		<div class="footer-top">
			<div class="footer-top-left">
				<div class="footer-top-left-left">
					<div class="footer-top-img">
						<a href="/"><img src="../assets/img/footerLogo.png" alt="" /></a>
						
					</div>
					<div class="footer-top-tel">联系电话</div>
					<div class="footer-top-phone">400-0451-000</div>
					<div class="footer-top-add">地址</div>
					<div class="footer-top-address">哈尔滨市松北区智谷二街3043号8号楼8层</div>
				</div>
				<div class="footer-top-left-right">
					<div class="footer-top-url">热门链接</div>
					<div class="footer-top-url-box">
						<div>
							<div><router-link to="./Index">关于中亚</router-link></div>
							<div><router-link to="./twoSystem">两大体系</router-link></div>
							<div><router-link to="./fourFeature">四大功能</router-link></div>
							<div><router-link to="./eightPlate">八大板块</router-link></div>
						</div>
						<div>
							<div><router-link to="./developmentPlanning">发展规划</router-link></div>
							<div><router-link to="./newsCenter">新闻中心</router-link></div>
							<div><router-link to="./socialResponsibility">社会责任</router-link></div>
							<div><router-link to="./aboutUs">联系我们</router-link></div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-top-tight">
				<div>关注/联系我们</div>
				<div class="footer-top-qrcode">
					<div>
						<img src="../assets/img/qrCode1.jpg" alt="" />
						<div class="footer-top-qrcode-name">中亚环保小程序</div>
					</div>
					<div>
						<img src="../assets/img/qrCode2.jpg" alt="" />
						<div class="footer-top-qrcode-name">中亚环保小程序</div>
					</div>
				</div>
			</div>
		</div>
		<div class="last-screen-bottom">黑ICP备2023004882号</div>
	</div>
</template>

<script>
export default {
	name: 'footer',
    data() {
      return {
       
      };
    },
    methods: {
      
    }
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/footer.scss';
a{
	color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue